
export const DEFAULTMESSAGES = 
    {
        speech:"Welcome....",
        userType:'chatbot',
        timestamp:'12:20:10 PM'
    }
